<header>
  <div [ngClass]="(isToggle==true)? (deviceType==='Desktop') ? 'nav_links_container _active' : (deviceType==='Mobile') ? 'nav_links_container min-nav _active' : 'nav_links_container tablet-nav _active' : (deviceType==='Desktop') ? 'nav_links_container' : (deviceType==='Mobile') ? 'nav_links_container min-nav' : 'nav_links_container tablet-nav'">
    <span class="__logo">
      <img src="assets/img/grt_logo_final.png" alt="">
      <code>GRT Global Logistics</code>
    </span>
    <div class="nav_links">
      <a class="__home" [routerLink]="[dashboardPath]" [routerLinkActive]="['__active']" >
        <mat-icon>home</mat-icon>
        <span class="__text">HOME</span>
      </a>
      <div class="__search">
        <mat-icon class="__icon">search</mat-icon>
        <input type="search" placeholder="Search for menu" [(ngModel)]="searchText">
      </div>
      <div class="nav_link_scroll">
        <div class="link_box">
          <mat-accordion class="example-headers-align" #accordion="matAccordion" multi>
            @for (item of menuItem | filter: searchText; track item) {
              <!-- | filter: term -->
              @if (item.separator) {
                <h2>{{item.label}}</h2>
              }
              @if (!item.separator && item.route && checkPermission(item.module)) {
                <ul class="prime_nav">
                  <li>
                    <a [class.__active]="isLinkActive(item.route)">
                      <img class="__icon" [src]="item.imgsrc" alt="" >
                      <span class="__text">
                        <div (click)="navigateOnClick(item.route,true)" class="h-100 side-text" #labelEl [matTooltip]="item.label" #labelTip="matTooltip" (mouseenter)="labelTip.disabled = labelEl.scrollWidth <= labelEl.offsetWidth" matTooltipPosition="right" matTooltipClass="white-tooltip">{{item.label}}</div>
                        <mat-icon [ngClass]="isLinkActive(item.route)?'hyperlink active':'hyperlink'" (click)="navigateOnClick(item.route,false)" matTooltip="Open link in new tab" matTooltipClass="white-tooltip">open_in_new</mat-icon>
                      </span>
                    </a>
                  </li>
                </ul>
              }
              @if (!item.separator && !item.route) {
                <ul class="prime_nav" href="#">
                  <li>
                    <mat-expansion-panel [expanded]="isSearching">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <a>
                            <img class="__icon" [src]="item.imgsrc" alt="">
                            <span class="__text">{{item.label}}</span>
                          </a>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      @if (item.children) {
                        <ul class="sub_nav">
                          @for (item of item.children; track item) {
                            <li>
                              @if (checkPermission(item.module)) {
                                <a
                                  [class.__active]="isLinkActive(item.route)">
                                  <div (click)="navigateOnClick(item.route,true)" class="h-100 side-text" #labelEl [matTooltip]="item.label" #labelTip="matTooltip" (mouseenter)="labelTip.disabled = labelEl.scrollWidth <= labelEl.offsetWidth" matTooltipPosition="right" matTooltipClass="white-tooltip">{{item.label}}</div>
                                  <mat-icon [ngClass]="isLinkActive(item.route)?'hyperlink wide active':'hyperlink wide'" (click)="navigateOnClick(item.route,false)" matTooltip="Open link in new tab" matTooltipClass="white-tooltip">open_in_new</mat-icon>
                                </a>
                              }
                              @if (checkPermission(item.module)) {
                                <img alt="">
                              }
                            </li>
                          }
                        </ul>
                      }
                    </mat-expansion-panel>
                  </li>
                </ul>
              }
            }
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="(deviceType === 'Desktop')? 'header_bar': (deviceType === 'Mobile')? 'header_bar mini-header_bar' :'header_bar tablet-header_bar' ">
    <nav>
      <div class="nav_filters">
        <form [formGroup]="cbsForm">
          <div class="flex_box">
            @if (deviceType !== 'Mobile') {
              <div class="filter_dropdown company_dropdown">
                <mat-label class="text-white fw-medium">Company</mat-label>
                <mat-select formControlName="company" appearance="fill" [disabled]="true">
                  @if (role==='ROLE_GSA') {
                    <mat-option [value] = null>None</mat-option>
                  }
                  @for (com of companys; track com) {
                    <mat-option [disabled] ="com.isCompanyDeactivated" [value]="com.companyId">
                      {{com.name}}
                    </mat-option>
                  }
                </mat-select>
              </div>
            }
            @if (deviceType !== 'Mobile') {
              <div class="filter_dropdown">
                <mat-label class="text-white fw-medium">Branch</mat-label>
                <mat-select formControlName="branch"  appearance="fill" [disabled]="true">
                  <mat-option [value] = null>None</mat-option>
                  @for (br of branches; track br) {
                    <mat-option [disabled] ="br.isBranchDeactivated" [value]="br.branchId">
                      {{br.name}}
                    </mat-option>
                  }
                </mat-select>
              </div>
            }
            <div class="filter_dropdown">
              <button mat-button (click)="onChange()" class="change-button" matTooltip="Change Company/Branch">
                <span>Change</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </nav>
    <div class="header_right_group">
      <div class="header_tools2">
        <button mat-button class="tracking-button" (click)="openTracking()" matTooltip="Go to Tracking Page">
          <mat-icon>location_on</mat-icon>
          <span>Tracking</span>
        </button>
      </div>
      <div class="header_tools">
        <div class="flex_box">
          <div class="nav_search">
            <i class="material-icons logout-icon" (click)="logout()" matTooltip="LogOut">logout</i>
          </div>
          <div class="nav_profile">
            <a class="__profil_pic"><img src="assets/img/profile.jpg" alt="Profile Img"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
